module.exports = __webpack_public_path__ + "img/IconInfo.4e85268f.svg";